import React, { useState, useContext, useEffect } from 'react';
import Section from '../section/section';
import LineChart from '../line-chart-review/line-chart-review';
import ChartCard from '../chart-card/chart-card';
import Context from '../../context/context';
import EstablishmentTypeToggle from '../establishment-type-toggle/establishment-type-toggle';

const DistributionOverTime = () => {
  const {
    filteredReviews,
    selectedCategory,
    selectedPlatform,
    selectedSubCategory,
    selectedSentiment,
    selectedAspect,
    selectedRegion,
  } = useContext(Context);

  function computeVisitsOverTime() {
    const monthMap = filteredReviews.reduce((reviewAcc, review) => {
      const date = new Date(review.travel_date);
      const monthKey = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, '0')}`;

      if (reviewAcc[monthKey]) {
        reviewAcc[monthKey] += 1;
      } else {
        reviewAcc[monthKey] = 1;
      }
      return reviewAcc;
    }, {});

    return Object.entries(monthMap)
      .map(([monthKey, count]) => {
        return {
          date: new Date(`${monthKey}-01`),
          value: count,
        };
      })
      .sort((a, b) => a.date - b.date);
  }

  function xTicksFormatter(value) {
    const options = { year: '2-digit', month: 'short' };
    return value.toLocaleString('en-US', options);
  }

  const [visitsOverTime, setVisitsOverTime] = useState(computeVisitsOverTime());

  useEffect(() => {
    setVisitsOverTime(computeVisitsOverTime());
  }, [filteredReviews]);

  const appliedFilters = {
    platform: selectedPlatform,
    category: selectedCategory,
    subcategories: selectedSubCategory,
    sentiment: selectedSentiment,
    aspects: selectedAspect,
    regions: selectedRegion,
  };

  return (
    <Section title={<span>Number of reviews over time</span>}>
      <EstablishmentTypeToggle />
      <ChartCard>
        <LineChart
          id="number-of-visits"
          data={visitsOverTime}
          xTicksFormatter={xTicksFormatter}
          columns={{ date: 'Date', value: 'Value' }}
          fileName="reviews-over-time"
          filters={appliedFilters}
          title={'Number of reviews over time'}
        />
      </ChartCard>
    </Section>
  );
};

export default DistributionOverTime;
